import scope from "@/constants/Scope";

const settings = {
    categoryName: "scrape",
    scope: scope,
  } as const;

  export default settings;